import { NgModule } from "@angular/core";
import { TrackableItemsSelectors } from "./trackable-items.selectors";
import { TrackableItemsActions } from "./trackable-items.actions";
import { STORE_FEATURE_KEY_TRACKABLE_ITEMS, TrackableItemsReducer } from "./trackable-items.reducer";
import { EffectsModule } from "@ngrx/effects";
import { TrackableItemsEffects } from "./trackable-items.effects";
import { StoreModule } from "@ngrx/store";
import { TrackableItemsService } from "./trackable-items.service";


@NgModule({
  imports: [
    StoreModule.forFeature(STORE_FEATURE_KEY_TRACKABLE_ITEMS, TrackableItemsReducer),
    EffectsModule.forFeature([TrackableItemsEffects]),
  ],
  providers: [
    TrackableItemsSelectors,
    TrackableItemsActions,
    TrackableItemsService
  ],
})
export class TrackableItemsModule {
}
